import React, { useEffect, useState } from "react";
import { Nav, Tab, Form, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import "./Vendor_Expert_Tabs.css";
import Popular_Vendors from "./popular_vendors/Popular_Vendors";
import Plumber_Expert from "./plumber-expert/Plumber_Expert";
import Painter_Expert from "./painter-experts/Painter_Experts";
import Popular_Expert from "./Popular_experts/Popular_Experts";
import Hardware_Vendors from "./hardware-vendor/Hardware_Vendor";
import Tiles_Vendors from "./tiles-vendor/Tiles_Vendor";
import { IDS } from "../../../utils/IDS";
import { icon } from "@fortawesome/fontawesome-svg-core";
// Vendor_Expert_Tabs.jsx
import { getVendorExpert } from "../../../features/admin/vendor_expert/Slice";
import { useDispatch } from "react-redux";

const vendorCategories = [
  { label: "Hardware", img: "/assets/images/Hardware.png" },
  { label: "Tiles", img: "/assets/images/Tiles.png" },
  { label: "Electronics", img: "/assets/images/Electronics.png" },
  { label: "Bricks", img: "/assets/images/Bricks.png" },
  { label: "Cement", img: "/assets/images/Cement.png" },
  { label: "Hardware", img: "/assets/images/Hardware.png" },
  { label: "Tiles", img: "/assets/images/Tiles.png" },
  { label: "Electronics", img: "/assets/images/Electronics.png" },
];
const expertCategories = [
  { label: "Plumber", img: "/assets/images/Plumber.png" },
  { label: "Painter", img: "/assets/images/Painter.png" },
  { label: "Carpenter", img: "/assets/images/Carpainter.png" },
  { label: "Electrician", img: "/assets/images/Electrician.png" },
  { label: "Pest Control", img: "/assets/images/Pest_Control.png" },
];

function Vendor_Expert_Tabs({ categories, professions }) {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("vendors");
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [selectedExperts, setSelectedExperts] = useState([]);
  const [selectedMaterialIds, setSelectedMaterialIds] = useState([]);
  const [selectedProfessionIds, setSelectedProfessionIds] = useState([]);
  const [searchName, setSearchName] = useState("");

  useEffect(() => {
    if (categories?.length) {
      setSelectedMaterialIds([categories[0].id]);
    }
  }, [categories]);

  useEffect(() => {
    if (professions?.length) {
      setSelectedProfessionIds([professions[0].id]);
    }
  }, [professions]);

  const toggleVendor = (materialId) => {
    setSelectedMaterialIds((prev) => {
      if (prev.includes(materialId)) {
        return prev.filter((id) => id !== materialId);
      }
      return [...prev, materialId];
    });
  };

  const toggleProfession = (professionId) => {
    setSelectedProfessionIds((prev) => {
      if (prev.includes(professionId)) {
        return prev.filter((id) => id !== professionId);
      }
      return [...prev, professionId];
    });
  };

  return (
    <section className="vendor-expert-section">
      <div className="container">
        <Tab.Container activeKey={activeTab} onSelect={setActiveTab}>
          <div className="vendor-expert-header">
            <Nav variant="pills" className="vendor-expert-tabs">
              <Nav.Item>
                <Nav.Link eventKey="vendors">Vendors</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="experts">Experts</Nav.Link>
              </Nav.Item>
            </Nav>
            <InputGroup className="vendor-search">
              <InputGroup.Text className="search-icon">
                <FontAwesomeIcon icon={faSearch} />
              </InputGroup.Text>
              {/* <Form.Control
                type="text"
                placeholder="Search"
                className="search-input"
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
              /> */}
              <Form.Control
                type="text"
                // placeholder={
                //   activeTab === "vendors"
                //     ? "Search Shop Name"
                //     : "Search Expert Name"
                // }
                placeholder="Search By Name"
                className="search-input"
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
              />
            </InputGroup>
          </div>
          <Tab.Content>
            <Tab.Pane eventKey="vendors">
              <div className="category-scroll-container">
                {/* {categories?.map((item, index) => (
                  <div
                    key={index}
                    className={`category-item ${
                      selectedVendors.includes(index) ? "selected" : ""
                    }`}
                    onClick={() => toggleVendor(index)}
                  > */}
                {categories?.map((item) => (
                  <div
                    key={item.id}
                    className={`category-item ${
                      selectedMaterialIds.includes(item.id) ? "selected" : ""
                    }`}
                    onClick={() => toggleVendor(item.id)}
                  >
                    <div className="category-card">
                      <div className="category-img">
                        <img
                          src={`${IDS.IMG_URL}${item.icon}`}
                          alt={item.name}
                        />
                      </div>
                    </div>

                    <p className="category-label">{item.name}</p>
                  </div>
                ))}
              </div>

              <Popular_Vendors
                selectedMaterialIds={selectedMaterialIds}
                categories={categories}
                activeTab={activeTab}
                searchName={searchName}
              />
              {/* <Hardware_Vendors />
              <Tiles_Vendors /> */}
            </Tab.Pane>
            <Tab.Pane eventKey="experts">
              <div className="category-scroll-container">
                {professions?.map((item) => (
                  <div
                    key={item.id}
                    className={`category-item ${
                      selectedProfessionIds.includes(item.id) ? "selected" : ""
                    }`}
                    onClick={() => toggleProfession(item.id)}
                  >
                    <div className="category-card">
                      <div className="category-img">
                        <img
                          src={`${IDS.IMG_URL}${item.icon}`}
                          alt={item.name}
                        />
                      </div>
                    </div>
                    <p className="category-label">{item.name}</p>
                  </div>
                ))}
              </div>
              <Popular_Expert
                professions={professions}
                selectedProfessionIds={selectedProfessionIds}
                searchName={searchName}
              />
              {/* <Plumber_Expert />
              <Painter_Expert /> */}
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </section>
  );
}
export default Vendor_Expert_Tabs;
